import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import {
    DataGrid, GridToolbarQuickFilter, GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip';
import {
    obtenerTodasLasSolicitudesWithStatusEnviado,
    AcualizarFormatoAccion, obetenerSolicitudDetalle,
    obetenerFormatoDetalle, obetenerAnexosDetalle,
    obtenerDatosLogin, actualizarSolicitud, obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado,
    obtenerIdCliente,
    obtenerTodosClientes,
    actualizarSolicitudes
} from '../../redux/DucksAtencionACliente/AtencionAClienteDucks'
// import { resetDataFC_01, obtenerFC_01Map, obtenerFC_01SolicitudDetalle } from '../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks'
import {
    resetDataFC_05, obtenerFC_05Map, setModoProcesoFC_05,
    setModoVerDetalleFC_05, setModoRecibidasCorregidasFC_05,
    actualizarFC_05Estatus, obtenerFC_05SolicitudDetalle
} from '../../redux/DucksAtencionACliente/FC_05AtencionAClienteDucks'
import {
    resetDataFC_06, obtenerFC_06Map, setModoVerDetalleFC_06,
    setModoRecibidasCorregidasFC_06, setModoProcesoFC_06,
    obtenerSolicitudDetalleFC_06, actualizarFC_06Estatus,
    generarDocumentosProductorMaguey
} from '../../redux/DucksAtencionACliente/FC_06AtencionAClienteDucks'
import {
    resetDataFC_08, obtenerFC_08Map, obtenerFC_08SolicitudDetalle,
    setModoVerDetalleFC_08, setModoRecibidasCorregidasFC_08, setModoProcesoFC_08,
    actualizarFC_08Estatus,
} from '../../redux/DucksAtencionACliente/FC_08AtencionAClienteDucks'
import { resetDataFC_09, obtenerSolicitudDetalleFC_09, obtenerFC_09Map, setModoVerDetalleFC_09, setModoProcesoFC_09, setModoRecibidasCorregidasFC_09, actualizarFC_09Estatus } from '../../redux/DucksAtencionACliente/FC_09AtencionAClienteDucks'
import {
    resetDataFC_30, obtenerFC_30Map, setModoProcesoFC_30,
    setModoVerDetalleFC_30, setModoRecibidasCorregidasFC_30,
    actualizarFC_30Estatus, obtenerSolicitudDetalleFC_30
} from '../../redux/DucksAtencionACliente/FC_30AtencionAClienteDucks'
import {
    resetDataFC_31, obtenerFC_31Map, actualizarFC_31Estatus,
    obtenerSolicitudDetalleFC_31, setModoVerDetalleFC_31, setModoRecibidasCorregidasFC_31, setModoProcesoFC_31
} from '../../redux/DucksAtencionACliente/FC_31AtencionAClienteDucks'
import {
    resetDataFC_33, obtenerFC_33Map, setModoVerDetalleFC_33,
    setModoProcesoFC_33, setModoRecibidasCorregidasFC_33, obtenerSolicitudDetalleFC_33,
    actualizarFC_33Estatus
} from '../../redux/DucksAtencionACliente/FC_33AtencionAClienteDucks'
import {
    resetDataFC_34, obtenerFC_34Map, setModoVerDetalleFC_34, actualizarFC_34Estatus,
    setModoProcesoFC_34, setModoRecibidasCorregidasFC_34, obtenerFC_34SolicitudDetalle
} from '../../redux/DucksAtencionACliente/FC_34AtencionAClienteDucks'

import {
    resetDataFC_35, obtenerFC_35Map, setModoVerDetalleFC_35,
    setModoRecibidasCorregidasFC_35, setModoProcesoFC_35,
    obtenerFC_35SolicitudDetalle
} from '../../redux/DucksAtencionACliente/FC_35AtencionAClienteDucks'

import {
    resetDataFC_36,// obtenerFC_36Map, 
    actualizarModoRevisionFC_36,
    obtenerFC_36Map, setModoVerDetalleFC_36,
    setModoRecibidasCorregidasFC_36, setModoProcesoFC_36,
    obtenerFC_36SolicitudDetalle, actualizarFC_36Estatus
} from '../../redux/DucksAtencionACliente/FC_36AtencionAClienteDucks'

import {
    resetDataFC_40, obtenerFC_40Map, setModoVerDetalleFC_40,
    setModoRecibidasCorregidasFC_40, setModoProcesoFC_40,
    obtenerFC_40SolicitudDetalle, actualizarFC_40Estatus
} from '../../redux/DucksAtencionACliente/FC_40AtencionAClienteDucks'

import {
    resetDataFC_41, obtenerFC_41Map, obtenerFC_41SolicitudDetalle,
    setModoRecibidasCorregidasFC_41, setModoProcesoFC_41, setModoVerDetalleFC_41
} from '../../redux/DucksAtencionACliente/FC_41AtencionAClienteDucks'
import { obetenerSolicitud } from '../../redux/SolicitudesDucks'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';

import estilos from './AtencionAClientesComponent.module.css';
import {
    actualizarFC_01Estatus, obtenerSolicitudDetalleFC_01, obtenerSolicitudDetalleFC_01ConMaps,
    setModoProceso, setModoRecibidasCorregidas, setModoVerDetalleFC_01
} from '../../redux/DucksAtencionACliente/FC_01AtencionAClienteDucks';
import BotonDescargarSolicitudComponent from '../App/BotonDescargarSolicitudComponent';
import { Title } from '@mui/icons-material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

{ {/*Estilos para el componente*/ } }
// import estilos from './AtencionAClientesFC_01Component.module.css';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
import DownloadIcon from '@mui/icons-material/Download';
import excelJS from 'exceljs'
import moment from "moment"
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../redux/AppDucks';

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
                textAlign: 'right'
            }}
        >
            {/*<GridToolbarFilterButton Title='Filtro'/>*/}
            <GridToolbarQuickFilter />
        </Box>
    );
}
import { saveAs } from 'file-saver';

function AtencionAClientesComponent(props) {

    const dispatch = useDispatch()
    const solicitudes = useSelector(store => store.AtencionSolicitud.data)
    console.log(solicitudes)
    const datosRevisores = useSelector(store => store.AtencionSolicitud.revisores)
    const dataUser = useSelector(store => store.Usuario.user)
    const clientes = useSelector(store => store.AtencionSolicitud.clientes)

    const fc_01_solicitudderegistro = [
        { idfc01_solicitudregistro: 2, Folio: 12, fechasolicitud: '07-05-2022', Nombre: 'fc_01_solicitudDeRegistro', idlogin: 1, revisor: "Jose Pedro Macario" },
        { idfc01_solicitudregistro: 2, Folio: 12, fechasolicitud: '07-05-2022', Nombre: 'fc_01_solicitudDeRegistro', idlogin: 1, revisor: "Juan del rio" },
        { idfc01_solicitudregistro: 2, Folio: 12, fechasolicitud: '07-05-2022', Nombre: 'fc_01_solicitudDeRegistro', idlogin: 1, revisor: "Maria San juan" },
        { idfc01_solicitudregistro: 2, Folio: 12, fechasolicitud: '07-05-2022', Nombre: 'fc_01_solicitudDeRegistro', idlogin: 1, revisor: "Josefa ortiz de domingues" },
        { idfc01_solicitudregistro: 2, Folio: 12, fechasolicitud: '07-05-2022', Nombre: 'fc_01_solicitudDeRegistro', idlogin: 1, revisor: "" },
    ]
    const solicitudesStatus = useSelector(store => store.AtencionSolicitud.status)
    React.useEffect(() => {
        if (solicitudesStatus === 0) {
            if (dataUser[0]?.idrol === 1) {
                dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
                setAncho(window.innerWidth)
            }
            else if (dataUser[0]?.idrol === 2) {
                dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 2, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: dataUser[0]?.idlogin }))
                setAncho(window.innerWidth)
            }
        }
    }, [dispatch, solicitudes.status, dataUser])

    React.useEffect(() => {
        dispatch(obtenerTodosClientes())
        setAncho(window.innerWidth)
    }, [dispatch])
    React.useEffect(() => {
        setAncho(window.innerWidth)
    }, [])
    async function RevisarFormulario(params) {

        const idSolicitud = params.row.Folio
        const nombre = params.row.Nombre
        const idlogin = params.row.idlogin
        const estatus = 3
        let tabla = 0
        const revision = true
        if (nombre == 'fc_01_solicitudderegistro') {
            tabla = 1
            // await dispatch(resetDataFC_01())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                // const detalleFC01 = await dispatch(obetenerFormatoDetalle('FC_01/obtenerUnaSolicitudFC_01Detalle/', idSolicitud))
                // const detalleFC01 = await dispatch(obtenerFC_01SolicitudDetalle(idSolicitud))

                props.history.push('/fc_01')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_05_solicitudusomarcaeimagen') {
            tabla = 2
            await dispatch(resetDataFC_05())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC05 = await dispatch(obetenerFormatoDetalle('FC_05/obtenerFormatoFC05/', idSolicitud))
                props.history.push('/fc_05')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_06_registrodemaguey') {
            tabla = 3
            await dispatch(resetDataFC_06())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC06 = await dispatch(obetenerFormatoDetalle('FC_06/obtenerFormatoFC06ConDetalle/', idSolicitud))
                props.history.push('/fc_06')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_08_solicitudrenvacioncertificados') {
            tabla = 4
            await dispatch(resetDataFC_08())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC08 = await dispatch(obetenerFormatoDetalle('FC_08/obtenerFormatoFC08_ConDetalle/', idSolicitud))
                props.history.push('/fc_08')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram') {
            tabla = 5
            await dispatch(resetDataFC_09())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC09 = await dispatch(obetenerFormatoDetalle('FC_09/obtenerFormatoFC09_ConDetalle/', idSolicitud))
                props.history.push('/fc_09')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_30_notificaciontrasladodeproducto') {
            tabla = 6
            await dispatch(resetDataFC_30())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC30 = await dispatch(obetenerFormatoDetalle('FC_30/obtenerFormatoFC30ConDetalle/', idSolicitud))
                props.history.push('/fc_30')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_31_solicitudseguimiento') {
            tabla = 7
            await dispatch(resetDataFC_31())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC31 = await dispatch(obetenerFormatoDetalle('FC_31/obtenerFormatoFC31ConDetalle/', idSolicitud))
                props.history.push('/fc_31')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_33_solicitudenvasadonacional') {
            tabla = 8
            await dispatch(resetDataFC_33())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC33 = await dispatch(obetenerFormatoDetalle('FC_33/obtenerFormatoFC33_ConDetalle/', idSolicitud))
                props.history.push('/fc_33')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_34_notificacionsuspencionyreactivacion') {
            tabla = 9
            await dispatch(resetDataFC_34())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC34 = await dispatch(obetenerFormatoDetalle('FC_34/obtenerFormatoFC34/', idSolicitud))
                props.history.push('/fc_34')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_35_notificaciondeserviciosvarios') {
            tabla = 10
            await dispatch(resetDataFC_35())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC35 = await dispatch(obetenerFormatoDetalle('FC_35/obtenerFormatoFC35/', idSolicitud))
                props.history.push('/fc_35')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_36_solicituddeactualizacion') {
            tabla = 11
            await dispatch(resetDataFC_36())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC36 = await dispatch(obetenerFormatoDetalle('FC_36/obtenerUnaSolicitudFC_36Detalle/', idSolicitud))
                props.history.push('/fc_36')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_40_solicituddeadquisiciondehologramas') {
            tabla = 12
            await dispatch(resetDataFC_40())
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC40 = await dispatch(obetenerFormatoDetalle('FC_40/obtenerFormatoFC40_ConDetalle/', idSolicitud))
                props.history.push('/fc_40')
            } else {
                // console.log("error")
            }
        }
        if (nombre == 'fc_41_solicitudparabebidasconmezcal') {
            tabla = 13
            const resultado = await dispatch(AcualizarFormatoAccion({ tabla, idSolicitud, estatus, idlogin, revision }))
            if (resultado) {
                const detalleFC41 = await dispatch(obetenerFormatoDetalle('FC_41/obtenerFormatoFC41ConDetalle/', idSolicitud))
                props.history.push('/fc_41')
            } else {
                // console.log("error")
            }
        }


    }

    const rowsRevisores = [
        // { id: uuidv4(), Nombre: 'Jose Pedro', Apellidos:'Mendoza Garcia', Correo: 'jope@gmail.com' },
        // { id: uuidv4(), Nombre: 'Maria del carmen', Apellidos:'Mendoza Garcia', Correo: 'Mari@gmail.com' },
        // { id: uuidv4(), Nombre: 'Juan del rio', Apellidos:'Mendoza Garcia', Correo: 'Juan@gmail.com' },
        // { id: uuidv4(), Nombre: 'Mariano Prieto de lado', Apellidos:'Mendoza Garcia', Correo: 'mariano@gmail.com' },
    ];
    for (const datoRevisor of datosRevisores) {
        if (datoRevisor.datoslogin?.estatus == true) rowsRevisores.push(
            {
                id: uuidv4(), Nombre: datoRevisor.datoslogin.nombre + ' ' + datoRevisor.datoslogin.apellidos,
                Telefono: datoRevisor.datoslogin.telefono, Correo: datoRevisor.usuario, Cartera: datoRevisor.datoslogin.cartera,
                nombreRevisor: datoRevisor.datoslogin.nombre, apellidosRevisor: datoRevisor.datoslogin.apellidos,
            },
        )
    }
    const columnsRevisores = [

        { field: 'Nombre', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Nombre Completo', width: 250 },
        // { field: 'Correo', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Correo', width: 250 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acción', width: 250,
            renderCell: (params) => (
                <>
                    <button onClick={() => handleOpenModal(params)} className={`btn btn-outline-warning`} >Asignar</button>

                </>
            )

        }
    ]
    const [openModalRevisores, setOpenModalRevisores] = React.useState(false);
    // const [titleModal, setTitleModal] = React.useState('');
    // const [bodyModal, setBodyModal] = React.useState('')
    // const [accion, setAccion] = React.useState('')
    const [idSolicitud, setIdSolicitud] = React.useState('')
    const [folio, setFolio] = React.useState('')
    const [solicitud, setSolicitud] = React.useState('')
    const handleOpenModalRevisores = (params) => {
        if (params.row.tipoSolicitud === 'Inscripción') {
            setSolicitud(params.row.tipoSolicitud)
            setIdSolicitud(params.row.id)
            setFolio(params.row.folio)
        } else if (params.row.Nombre === 'fc_36_solicituddeactualizacion') {
            setSolicitud(params.row.Nombre)
            setIdSolicitud(params.row.Folio)
            setFolio(params.row.folio)
        } else {
            setSolicitud(params.row.tipoSolicitud)
            setIdSolicitud(params.row.Folio)
            setFolio(params.row.folio)
        }

        const datos = dispatch(obtenerDatosLogin())

        setOpenModalRevisores(true)
    }
    const handleCloseModalRevisores = () => {
        // setTitleModal('')
        // setBodyModal('')
        // setAccion('')
        setOpenModalRevisores(false)
    }

    const modalComponentRevisores = () => {
        return (
            <div>
                <Modal
                    open={openModalRevisores}
                    onClose={handleCloseModalRevisores}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <div align="right">
                            <button className='btn btn-outline-danger' onClick={() => { handleCloseModalRevisores() }}>X</button>
                            {/*style={{ background: '#ff9800', color: 'white' }}*/}
                        </div>
                        <Typography id="modal-modal-title" variant="h4" component="h2" className='text-center'>
                            {/* Asignación de revisores a solicitudes */}
                            Asignación de ejecutivas(os)
                        </Typography>
                        {/* <br /><br /> */}
                        <div className='row justify-content-center'>
                            <div className='col-8 bg-white'>
                                <div style={{ height: 450, width: '105%' }}>
                                    <DataGrid
                                        rows={rowsRevisores}
                                        columns={columnsRevisores}
                                        pageSize={6}
                                        rowsPerPageOptions={[7]}
                                        sx={{
                                            boxShadow: 0,
                                            color: 'black',
                                            border: 0,
                                            '& .MuiDataGrid-cell': {
                                                display: 'block',
                                                position: 'relative',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <LineChart width={1100} height={300} data={data}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="uv" stroke="#8884d8" />
                        <Line type="monotone" dataKey="pv" stroke="#82ca9d" />
                    </LineChart> */}

                    </Box>
                </Modal>
            </div>
        )
    }
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [nombreRevisor, setNombreRevisor] = React.useState('')
    const handleOpenModal = (params) => {
        setTitleModal('Advertencia')
        setNombreRevisor(params.row.Nombre)
        setBodyModal('¿Esta seguro que desea asignar a ' + params.row.Nombre + ' la solicitud ' + folio + '?')
        // setAccion(data.accion)
        setOpenModal(true)

    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style1}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-2'>
                                <button className='btn btn-dark' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className='col-md-3 ms-5'></div>
                            <div className={`col-md-2`}>
                                <button className='btn btn-dark' onClick={() => { handleCloseModal() }}>CANCELAR</button>
                            </div>
                        </div>
                        {/* <div className='col-md-2'></div>
                        <div className='col-md-2'>
                            <button className='btn btn-dark' >CONTINUAR</button>
                        </div> */}
                    </Box>
                </Modal>
            </div>
        )
    }
    async function botonGuardar() {
        if (solicitud === 'Inscripción') await dispatch(actualizarSolicitud({ data: { idSolicitud, nombreRevisor } }))

        if (solicitud === 'Venta nacional') {
            let data = { tabla: 'fc_33_solicitudenvasadonacional', id: idSolicitud, idname: 'idfc33_solicitudenvasadonaciona', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Certificado NOM para exportación') {
            let data = { tabla: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram', id: idSolicitud, idname: 'idfc09_solicitudcertificado', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Traslado de producto') {
            let data = { tabla: 'fc_30_notificaciontrasladodeproducto', id: idSolicitud, idname: 'idfc30_notificaciontrasladodepr', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Uso marca e imagen COMERCAM') {
            let data = { tabla: 'fc_05_solicitudusomarcaeimagen', id: idSolicitud, idname: 'idfc05_solicitudusomarcaeimagen', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Servicios varios') {
            let data = { tabla: 'fc_35_notificaciondeserviciosvarios', id: idSolicitud, idname: 'idfc35_notificacionserviciosvar', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Registro de maguey') {
            let data = { tabla: 'fc_06_registrodemaguey', id: idSolicitud, idname: 'idfc06_registromaguey', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Renovación de certificados') {
            let data = { tabla: 'fc_08_solicitudrenvacioncertificados', id: idSolicitud, idname: 'idfc08_renvacioncertificado', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Compra de hologramas') {
            let data = { tabla: 'fc_40_solicituddeadquisiciondehologramas', id: idSolicitud, idname: 'idfc40_solicitudadquisicionholo', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Notificación suspensión y reactivación') {
            let data = { tabla: 'fc_34_notificacionsuspencionyreactivacion', id: idSolicitud, idname: 'idfc34_notificacionsuspencion', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Productos con mezcal') {
            let data = { tabla: 'fc_41_solicitudparabebidasconmezcal', id: idSolicitud, idname: 'idfc41_solicitudparabebidasconm', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'Seguimiento') {
            let data = { tabla: 'fc_31_solicitudseguimiento', id: idSolicitud, idname: 'idfc31_solicitudseguimiento', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (solicitud === 'fc_36_solicituddeactualizacion') {
            let data = { tabla: 'fc_36_solicituddeactualizacion', id: idSolicitud, idname: 'idfc36_solicitudactualizacion', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        handleCloseModalRevisores()
        handleCloseModal()
        await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 2 }))
        props.history.push('/AtencionAClientesComponent')
    }
    async function revisarFormato(params) {
        if (params.row.Nombre === "fc_01_solicitudderegistro") {
            const detalle = await dispatch(obtenerSolicitudDetalleFC_01(params.id))
            await dispatch(setModoRecibidasCorregidas(false))
            await dispatch(setModoProceso(true))
            await dispatch(setModoVerDetalleFC_01(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_01Estatus(
                    { data: { idSolicitud: params.id, estatus: 3, folio: detalle.payload.folio } }
                ))
            }
            props.history.push('/FC_01AtencionAClientesComponent')
        }
        if (params.row.Nombre === "fc_09_solicitudemicioncertificadonomexportacionyentregahologram") {
            await dispatch(resetDataFC_09())
            const detalle = await dispatch(obtenerSolicitudDetalleFC_09(params.row.Folio))
            await dispatch(setModoProcesoFC_09(true))
            await dispatch(setModoVerDetalleFC_09(false))
            await dispatch(setModoRecibidasCorregidasFC_09(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_09Estatus(
                    { data: { tabla: 4, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_09')
        }
        if (params.row.Nombre === "fc_30_notificaciontrasladodeproducto") {
            await dispatch(resetDataFC_30())
            const detalle = await dispatch(obtenerSolicitudDetalleFC_30(params.row.Folio))
            await dispatch(setModoProcesoFC_30(true))
            await dispatch(setModoVerDetalleFC_30(false))
            await dispatch(setModoRecibidasCorregidasFC_30(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_30Estatus(
                    { data: { tabla: 5, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_30')
        }
        if (params.row.Nombre === "fc_33_solicitudenvasadonacional") {
            await dispatch(resetDataFC_33())
            const detalle = await dispatch(obtenerSolicitudDetalleFC_33(params.row.Folio))
            await dispatch(setModoProcesoFC_33(true))
            await dispatch(setModoVerDetalleFC_33(false))
            await dispatch(setModoRecibidasCorregidasFC_33(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_33Estatus(
                    { data: { tabla: 7, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_33')
        }
        if (params.row.Nombre === "fc_05_solicitudusomarcaeimagen") {
            await dispatch(resetDataFC_05())
            const detalle = await dispatch(obtenerFC_05SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_05(true))
            await dispatch(setModoVerDetalleFC_05(false))
            await dispatch(setModoRecibidasCorregidasFC_05(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_05Estatus(
                    { data: { tabla: 1, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_05')
        }
        if (params.row.Nombre === "fc_35_notificaciondeserviciosvarios") {
            await dispatch(resetDataFC_35())
            const detalle = await dispatch(obtenerFC_35SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_35(true))
            await dispatch(setModoVerDetalleFC_35(false))
            await dispatch(setModoRecibidasCorregidasFC_35(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_05Estatus(
                    { data: { tabla: 9, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_35')
        }
        if (params.row.Nombre === "fc_06_registrodemaguey") {
            await dispatch(resetDataFC_06())
            const detalle = await dispatch(obtenerSolicitudDetalleFC_06(params.row.Folio))
            await dispatch(setModoProcesoFC_06(true))
            await dispatch(setModoVerDetalleFC_06(false))
            await dispatch(setModoRecibidasCorregidasFC_06(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_06Estatus(
                    { data: { tabla: 2, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_06')
        }
        if (params.row.Nombre === "fc_08_solicitudrenvacioncertificados") {
            await dispatch(resetDataFC_08())
            const detalle = await dispatch(obtenerFC_08SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_08(true))
            await dispatch(setModoVerDetalleFC_08(false))
            await dispatch(setModoRecibidasCorregidasFC_08(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_08Estatus(
                    { data: { tabla: 3, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_08')
        }
        if (params.row.Nombre === "fc_40_solicituddeadquisiciondehologramas") {
            await dispatch(resetDataFC_40())
            const detalle = await dispatch(obtenerFC_40SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_40(true))
            await dispatch(setModoVerDetalleFC_40(false))
            await dispatch(setModoRecibidasCorregidasFC_40(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_40Estatus(
                    { data: { tabla: 11, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_40')
        }
        if (params.row.Nombre === "fc_34_notificacionsuspencionyreactivacion") {
            await dispatch(resetDataFC_34())
            const detalle = await dispatch(obtenerFC_34SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_34(true))
            await dispatch(setModoVerDetalleFC_34(false))
            await dispatch(setModoRecibidasCorregidasFC_34(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_34Estatus(
                    { data: { tabla: 8, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_34')
        }
        if (params.row.Nombre === "fc_41_solicitudparabebidasconmezcal") {
            await dispatch(resetDataFC_41())
            const detalle = await dispatch(obtenerFC_41SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_41(true))
            await dispatch(setModoVerDetalleFC_41(false))
            await dispatch(setModoRecibidasCorregidasFC_41(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_34Estatus(
                    { data: { tabla: 12, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_41')
        }
        if (params.row.Nombre === "fc_31_solicitudseguimiento") {
            await dispatch(resetDataFC_31())
            const detalle = await dispatch(obtenerSolicitudDetalleFC_31(params.row.Folio))
            await dispatch(setModoProcesoFC_31(true))
            await dispatch(setModoVerDetalleFC_31(false))
            await dispatch(setModoRecibidasCorregidasFC_31(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_31Estatus(
                    { data: { tabla: 6, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_31')
        }
        if (params.row.Nombre === "fc_36_solicituddeactualizacion") {
            await dispatch(resetDataFC_36())
            const detalle = await dispatch(obtenerFC_36SolicitudDetalle(params.row.Folio))
            await dispatch(setModoProcesoFC_36(true))
            await dispatch(setModoVerDetalleFC_36(false))
            await dispatch(setModoRecibidasCorregidasFC_36(false))
            if (solicitudesStatus !== 3) {
                await dispatch(actualizarFC_36Estatus(
                    { data: { tabla: 10, idSolicitud: params.row.Folio, estatus: 3, idCliente: null, folio: params.row.folio } }
                ))
            }
            props.history.push('/fc_36')
        }
    }
    async function estatus(params) {
        const estatus = await dispatch(obtenerDatosLogin(params))

    }

    async function corregirButton(params) {
        const idSolicitud = params.row.Folio
        //let formato = params.row.formato
        const nombre = params.row.Nombre
        let vari = nombre.substring(0, 5)
        let formato = vari.toUpperCase()
        switch (formato) {
            case 'FC_01':

                const detalle = await dispatch(obtenerSolicitudDetalleFC_01ConMaps(params.id))
                await dispatch(setModoRecibidasCorregidas(true))
                await dispatch(setModoProceso(false))
                await dispatch(setModoVerDetalleFC_01(false))
                props.history.push('/FC_01AtencionAClientesComponent')
                break;
            case 'FC_05':
                await dispatch(resetDataFC_05())
                const detalleFC_05 = await dispatch(obtenerFC_05SolicitudDetalle(params.row.Folio))
                await dispatch(obtenerFC_05Map(idSolicitud))
                props.history.push('/fc_05')
                break;
            case 'FC_06':
                await dispatch(resetDataFC_06())
                const detalleFC_06 = await dispatch(obtenerSolicitudDetalleFC_06(params.row.Folio))
                await dispatch(obtenerFC_06Map(idSolicitud))
                props.history.push('/fc_06')
                break;
            case 'FC_08':
                await dispatch(resetDataFC_08())
                await dispatch(obtenerFC_08Map(idSolicitud))
                const detalleFC08 = await dispatch(obtenerFC_08SolicitudDetalle(params.row.Folio))
                props.history.push('/fc_08')
                break;
            case 'FC_09':
                await dispatch(resetDataFC_09())
                const detalleFC_09 = await dispatch(obtenerSolicitudDetalleFC_09(params.row.Folio))
                await dispatch(obtenerFC_09Map(idSolicitud))
                props.history.push('/fc_09')
                break;
            case 'FC_30':
                await dispatch(resetDataFC_30())
                await dispatch(obtenerFC_30Map(idSolicitud))
                const detalleFC30 = await dispatch(obtenerSolicitudDetalleFC_30(params.row.Folio))
                props.history.push('/fc_30')
                break;
            case 'FC_31':
                await dispatch(resetDataFC_31())
                await dispatch(obtenerFC_31Map(idSolicitud))
                const detalleFC31 = await dispatch(obtenerSolicitudDetalleFC_31(params.row.Folio))
                props.history.push('/fc_31')
                break;
            case 'FC_33':
                await dispatch(resetDataFC_33())
                await dispatch(obtenerFC_33Map(idSolicitud))
                const detalleFC_33 = await dispatch(obtenerSolicitudDetalleFC_33(params.row.Folio))
                props.history.push('/fc_33')
                //const detalleFC33 = await dispatch(obetenerFormatoDetalle('FC_33/obtenerFormatoFC33_ConDetalle/', idSolicitud))
                break;
            case 'FC_34':
                await dispatch(resetDataFC_34())
                const detalleFC_34 = await dispatch(obtenerFC_34SolicitudDetalle(params.row.Folio))
                await dispatch(obtenerFC_34Map(idSolicitud))
                props.history.push('/fc_34')
                break;
            case 'FC_35':
                await dispatch(resetDataFC_35())
                const detalleFC_35 = await dispatch(obtenerFC_35SolicitudDetalle(params.row.Folio))
                await dispatch(obtenerFC_35Map(idSolicitud))
                props.history.push('/fc_35')
                break;
            case 'FC_36':
                await dispatch(resetDataFC_36())
                await dispatch(actualizarModoRevisionFC_36(true))
                await dispatch(obtenerFC_36SolicitudDetalle(params.row.Folio))
                props.history.push('/fc_36')
                break;
            case 'FC_40':
                await dispatch(resetDataFC_40())
                const detalleFC_40 = await dispatch(obtenerFC_40SolicitudDetalle(params.row.Folio))
                await dispatch(obtenerFC_40Map(idSolicitud))
                props.history.push('/fc_40')
                break;
            case 'FC_41':
                await dispatch(resetDataFC_41())
                await dispatch(obtenerFC_41Map(idSolicitud))
                const detalleFC41 = await dispatch(obtenerFC_41SolicitudDetalle(params.row.Folio))
                props.history.push('/fc_41')
                break;
            default:
                break;
        }
    }

    const nameTablaDocumentos = {
        fc_01_solicitudderegistro: 'fc_01_documentos',
        name_fc_01_solicitudderegistro: 'idfc01_solicitudregistro',
        fc_09_solicitudemicioncertificadonomexportacionyentregahologram: 'fc_09_documentos',
        name_fc_09_solicitudemicioncertificadonomexportacionyentregahologram: 'idfc09_solicitudcertificado',
        fc_33_solicitudenvasadonacional: 'fc_33_documentos',
        name_fc_33_solicitudenvasadonacional: 'idfc33_solicitudenvasadonaciona',
        fc_30_notificaciontrasladodeproducto: 'fc_30_documentos',
        name_fc_30_notificaciontrasladodeproducto: 'idfc30_notificaciontrasladodepr',
        fc_05_solicitudusomarcaeimagen: 'fc_05_documentos',
        name_fc_05_solicitudusomarcaeimagen: 'idfc05_solicitudusomarcaeimagen',
        fc_35_notificaciondeserviciosvarios: 'fc_35_documentos',
        name_fc_35_notificaciondeserviciosvarios: 'idfc35_notificacionserviciosvar',
        fc_06_registrodemaguey: 'fc_06_documentos',
        name_fc_06_registrodemaguey: 'idfc06_registromaguey',
        fc_08_solicitudrenvacioncertificados: 'fc_08_documentos',
        name_fc_08_solicitudrenvacioncertificados: 'idfc08_renvacioncertificado',
        fc_40_solicituddeadquisiciondehologramas: 'fc_40_documentos',
        name_fc_40_solicituddeadquisiciondehologramas: 'idfc40_solicitudadquisicionholo',
        fc_34_notificacionsuspencionyreactivacion: 'fc_34_documentos',
        name_fc_34_notificacionsuspencionyreactivacion: 'idfc34_notificacionsuspencion',
        fc_41_solicitudparabebidasconmezcal: 'fc_41_documentos',
        name_fc_41_solicitudparabebidasconmezcal: 'idfc41_solicitudparabebidasconm',
        fc_31_solicitudseguimiento: 'fc_31_documentos',
        name_fc_31_solicitudseguimiento: 'idfc31_solicitudseguimiento',
        fc_36_solicituddeactualizacion: 'fc_36_documentos',
        name_fc_36_solicituddeactualizacion: 'idfc36_solicitudactualizacion',

    }
    async function verDetalle(params) {

        const idSolicitud = params.row.Folio
        //let formato = params.row.formato
        const nombre = params.row.Nombre
        let vari = nombre.substring(0, 5)
        let formato = vari.toUpperCase()

        switch (formato) {
            case 'FC_01':
                const detalle = await dispatch(obtenerSolicitudDetalleFC_01ConMaps(params.id))
                await dispatch(setModoVerDetalleFC_01(true))
                await dispatch(setModoRecibidasCorregidas(false))
                await dispatch(setModoProceso(false))
                props.history.push('/FC_01AtencionAClientesComponent')
                break;
            case 'FC_05':
                await dispatch(resetDataFC_05())
                const detalleFC_095 = await dispatch(obtenerFC_05SolicitudDetalle(params.row.Folio))
                await dispatch(setModoVerDetalleFC_05(true))
                await dispatch(obtenerFC_05Map(idSolicitud))
                props.history.push('/fc_05')
                break;
            case 'FC_06':
                await dispatch(resetDataFC_06())
                const detalleFC_06 = await dispatch(obtenerSolicitudDetalleFC_06(params.row.Folio))
                await dispatch(setModoVerDetalleFC_06(true))
                await dispatch(obtenerFC_06Map(idSolicitud))
                props.history.push('/fc_06')
                break;
            case 'FC_08':

                await dispatch(resetDataFC_08())
                const detalleFC_08 = await dispatch(obtenerFC_08SolicitudDetalle(params.row.Folio))
                await dispatch(setModoVerDetalleFC_08(true))
                await dispatch(obtenerFC_08Map(idSolicitud))
                props.history.push('/fc_08')
                break;
            case 'FC_09':
                await dispatch(resetDataFC_09())
                const detalleFC_09 = await dispatch(obtenerSolicitudDetalleFC_09(params.row.Folio))
                await dispatch(setModoVerDetalleFC_09(true))
                await dispatch(obtenerFC_09Map(idSolicitud))
                props.history.push('/fc_09')
                break;
            case 'FC_30':
                await dispatch(resetDataFC_30())
                const detalleFC_30 = await dispatch(obtenerSolicitudDetalleFC_30(params.row.Folio))
                await dispatch(setModoVerDetalleFC_30(true))
                await dispatch(obtenerFC_30Map(idSolicitud))
                props.history.push('/fc_30')
                break;
            case 'FC_31':
                await dispatch(resetDataFC_31())
                const detalleFC31 = await dispatch(obtenerSolicitudDetalleFC_31(params.row.Folio))
                await dispatch(obtenerFC_31Map(idSolicitud))
                await dispatch(setModoVerDetalleFC_31(true))
                props.history.push('/fc_31')
                break;
            case 'FC_33':
                await dispatch(resetDataFC_33())
                const detalleFC_33 = await dispatch(obtenerSolicitudDetalleFC_33(params.row.Folio))
                await dispatch(setModoVerDetalleFC_33(true))
                await dispatch(obtenerFC_33Map(idSolicitud))
                props.history.push('/fc_33')
                break;
            case 'FC_34':
                await dispatch(resetDataFC_34())
                //await dispatch(setModoCorrecionFC_34(true))
                await dispatch(obtenerFC_34Map(idSolicitud))
                const detalleFC34 = await dispatch(obtenerFC_34SolicitudDetalle(params.row.Folio))
                await dispatch(setModoVerDetalleFC_34(true))
                props.history.push('/fc_34')
                break;
            case 'FC_35':
                await dispatch(resetDataFC_35())
                const detalleFC_35 = await dispatch(obtenerFC_35SolicitudDetalle(params.row.Folio))
                await dispatch(setModoVerDetalleFC_35(true))
                await dispatch(obtenerFC_35Map(idSolicitud))
                props.history.push('/fc_35')
                break;
            case 'FC_36':
                await dispatch(resetDataFC_36())
                await dispatch(setModoVerDetalleFC_36(true))
                await dispatch(obtenerFC_36SolicitudDetalle(params.row.Folio))
                await dispatch(obtenerFC_36Map(idSolicitud))
                props.history.push('/fc_36')
                break;
            case 'FC_40':
                await dispatch(resetDataFC_40())
                const detalleFC_40 = await dispatch(obtenerFC_40SolicitudDetalle(params.row.Folio))
                await dispatch(setModoVerDetalleFC_40(true))
                await dispatch(obtenerFC_40Map(idSolicitud))
                props.history.push('/fc_40')
                break;
            case 'FC_41':
                await dispatch(resetDataFC_41())
                await dispatch(obtenerFC_41Map(idSolicitud))
                await dispatch(setModoVerDetalleFC_41(true))
                await dispatch(obtenerFC_41SolicitudDetalle(params.row.Folio))
                props.history.push('/fc_41')
                break;
            default:
                break;
        }
    }
    const [ancho, setAncho] = React.useState(0)
    const obtenerAncho = () => {
        const anchoPantalla = window.innerWidth
        return anchoPantalla
    }
    let columns = []

    if (solicitudesStatus == 4) columns = [
        /*{ field: 'id', headerName: 'ID', with: 30 },*/
        { field: 'folio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Folio', flex: .4 },
        {
            field: 'numerosolicitudservicios', headerName: 'No. Servicio', flex: .4, headerClassName: estilos.headerSolicitudes,
            renderCell: (params) =>
                <Tooltip title={`${params?.row?.numerosolicitudservicios || ''}`} arrow>
                    <label>{`${params?.row?.numerosolicitudservicios || ''}`}</label>
                </Tooltip>
        },
        {
            field: 'FechaDecreación', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Fecha de solicitud', flex: .5,
            renderCell: (params) =>
            (
                solicitudesStatus == 4 ?
                    <div>
                        <Tooltip title={`${params.row.FechaDecreación + ' '} ${(params.row.hora_solicitud != null || params.row.hora_solicitud != undefined) ? new Date(params.row.hora_solicitud).toISOString().substring(11, 19) : ''}`} arrow>
                            <label>{`${params.row.FechaDecreación + ' '}${(params.row.hora_solicitud != null || params.row.hora_solicitud != undefined) ? new Date(params.row.hora_solicitud).toISOString().substring(11, 19) : ''}`}</label>
                        </Tooltip>
                    </div> :
                    <div>
                        <Tooltip title={`${params.row.FechaDecreación}`} arrow>
                            <label>{`${params.row.FechaDecreación}`}</label>
                        </Tooltip>
                    </div>
            )
        },
        {
            field: 'tipoSolicitud', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Tipo Solicitud', flex: 1,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipoSolicitud}`} arrow>
                        <label>{`${params.row.tipoSolicitud}`}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'noSocio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'No. de socio', flex: .4 },
        { field: 'nombreRazon', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Razón social', flex: .5 },
        { field: 'Revisor', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Ejecutivo de AC', flex: .5 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acción', flex: .8,
            renderCell: (params) =>
            (
                solicitudesStatus === 2 ? (
                    params.row.Revisor === "" || params.row.Revisor === null ?
                        (
                            <>
                                {

                                    dataUser[0]?.idrol === 1 && params.row.Nombre === "fc_01_solicitudderegistro" &&
                                    <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnRed}`}>Asignar</button>
                                }
                                <button onClick={() => revisarFormato(params)} className={`btn ${estilos.btnNaranja}`}>Revisar</button>
                            </>
                        ) : (
                            <>
                                {
                                    dataUser[0]?.idrol === 1 &&
                                    <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnGreen}`}>Reasignar</button>
                                }
                                <button onClick={() => revisarFormato(params)} className={` btn ${estilos.btnNaranja}`}>Revisar</button>

                            </>
                        )
                ) : solicitudesStatus === 6 ? (

                    <button onClick={() => corregirButton(params)} className='btn btn-danger btn-sm'>Revisar corregidas</button>
                    //<button onClick={() => RevisarFormulario(params)} className='btn btnNaranja btn-sm'></button>
                ) : solicitudesStatus === 5 ?
                    (
                        <>
                            <button onClick={() => verDetalle(params)} className='btn btn-secondary btn-sm'>Ver detalle</button>
                        </>

                    ) : solicitudesStatus === 4 ?
                        <Fragment>
                            <BotonDescargarSolicitudComponent nameTabla={nameTablaDocumentos[params.row.Nombre]} nameFK={nameTablaDocumentos['name_' + params.row.Nombre]} idSolicitud={params.row.Folio !== undefined ? params.row.Folio : params.row.id} user='AtencionACliente'></BotonDescargarSolicitudComponent>
                            <button onClick={() => verDetalle(params)} className='btn btn-sm me-2' style={{ backgroundColor: '#68813c', color: 'white' }}>Ver</button>
                            {params.row.Nombre === "fc_01_solicitudderegistro" && params.row.productormaguey && <IconButton
                                onClick={() => btnProductor(params)}
                                size="small"
                                sx={{
                                    backgroundColor: '#68813c',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#5a7032'
                                    }
                                }}
                            >
                                <PictureAsPdfIcon />
                            </IconButton>}
                        </Fragment> :
                        solicitudesStatus === 3 ? (
                            params.row.Revisor === "" || params.row.Revisor === null ?
                                (
                                    <>
                                        {

                                            dataUser[0]?.idrol === 1 && params.row.Nombre === "fc_01_solicitudderegistro" &&
                                            <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnRed}`}>Asignar</button>
                                        }
                                        <button onClick={() => corregirButton(params)} className={`btn ${estilos.btnNaranja}`}>Revisar</button>
                                    </>
                                ) : (
                                    <>
                                        {
                                            dataUser[0]?.idrol === 1 &&
                                            <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnGreen}`}>Reasignar</button>
                                        }
                                        <button onClick={() => corregirButton(params)} className={` btn ${estilos.btnNaranja}`}>Revisar</button>

                                    </>
                                )
                        ) : ''
            )
        }
    ]
    else columns = [
        /*{ field: 'id', headerName: 'ID', with: 30 },*/
        { field: 'folio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Folio', flex: .4 },

        { field: 'FechaDecreación', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Fecha de solicitud', flex: .4 },
        {
            field: 'tipoSolicitud', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Tipo Solicitud', flex: 1,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipoSolicitud}`} arrow>
                        <label>{`${params.row.tipoSolicitud}`}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'noSocio', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'No. de socio', flex: .3 },
        { field: 'nombreRazon', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Razón social', flex: .7 },
        { field: 'Revisor', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Ejecutivo de AC', flex: .5 },
        {
            field: 'accion', headerAlign: 'center', headerClassName: estilos.headerSolicitudes, headerName: 'Acción', flex: .7,
            renderCell: (params) =>
            (
                solicitudesStatus === 2 ? (
                    params.row.Revisor === "" || params.row.Revisor === null ?
                        (
                            <>
                                {

                                    dataUser[0]?.idrol === 1 && params.row.Nombre === "fc_01_solicitudderegistro" &&
                                    <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnRed}`}>Asignar</button>
                                }
                                <button onClick={() => revisarFormato(params)} className={`btn ${estilos.btnNaranja}`}>Revisar</button>
                            </>
                        ) : (
                            <>
                                {
                                    dataUser[0]?.idrol === 1 &&
                                    <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnGreen}`}>Reasignar</button>
                                }
                                <button onClick={() => revisarFormato(params)} className={` btn ${estilos.btnNaranja}`}>Revisar</button>

                            </>
                        )
                ) : solicitudesStatus === 6 ? (

                    <button onClick={() => corregirButton(params)} className='btn btn-danger btn-sm'>Revisar corregidas</button>
                    //<button onClick={() => RevisarFormulario(params)} className='btn btnNaranja btn-sm'></button>
                ) : solicitudesStatus === 5 ?
                    (
                        <>
                            <button onClick={() => verDetalle(params)} className='btn btn-secondary btn-sm'>Ver detalle</button>
                        </>

                    ) : solicitudesStatus === 4 ?
                        <Fragment>
                            <BotonDescargarSolicitudComponent nameTabla={nameTablaDocumentos[params.row.Nombre]} nameFK={nameTablaDocumentos['name_' + params.row.Nombre]} idSolicitud={params.row.Folio !== undefined ? params.row.Folio : params.row.id} user='AtencionACliente'></BotonDescargarSolicitudComponent>
                            <button onClick={() => verDetalle(params)} className='btn btn-sm' style={{ backgroundColor: '#68813c', color: 'white' }}>Ver documentación</button>
                        </Fragment> :
                        solicitudesStatus === 3 ? (
                            params.row.Revisor === "" || params.row.Revisor === null ?
                                (
                                    <>
                                        {

                                            dataUser[0]?.idrol === 1 && params.row.Nombre === "fc_01_solicitudderegistro" &&
                                            <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnRed}`}>Asignar</button>
                                        }
                                        <button onClick={() => corregirButton(params)} className={`btn ${estilos.btnNaranja}`}>Revisar</button>
                                    </>
                                ) : (
                                    <>
                                        {
                                            dataUser[0]?.idrol === 1 &&
                                            <button onClick={() => handleOpenModalRevisores(params)} className={`btn ${estilos.btnGreen}`}>Reasignar</button>
                                        }
                                        <button onClick={() => corregirButton(params)} className={` btn ${estilos.btnNaranja}`}>Revisar</button>

                                    </>
                                )
                        ) : ''
            )
        }
    ]

    const rows = [];
    {
        solicitudes.fc_01_solicitudderegistro.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), id: solicitud.idfc01_solicitudregistro, folio: solicitud.folio,
                noSocio: solicitud.numerosocio !== undefined ? solicitud.numerosocio?.toString().length > 0 ? solicitud.numerosocio : '' : '',
                FechaDecreación: fecha, tipoSolicitud: 'Inscripción', nombreRazon: solicitud.nombrerazonsocial,
                Nombre: 'fc_01_solicitudderegistro', idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
                uri: 'FC_01/obtenerUnaSolicitudFC_01/', uriAnexos: 'FC_01/obtenerAnexosDeSolicitudDeRegistro/',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, hora_solicitud: solicitud?.hora_solicitud,
                productormaguey: solicitud?.productormaguey,

            })
        })
        solicitudes.fc_05_solicitudusomarcaeimagen.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc05_solicitudusomarcaeimagen, FechaDecreación: fecha,
                tipoSolicitud: 'Uso marca e imagen COMERCAM', nombreRazon: solicitud.nombrerazonsocial,
                noSocio: solicitud.numerocliente, Nombre: 'fc_05_solicitudusomarcaeimagen',
                idlogin: solicitud.idlogin, uri: 'FC_05/obtenerFormatoFC05/',
                Revisor: nombre?.[0] !== undefined ? revisor : '', hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_06_registrodemaguey.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc06_registromaguey, FechaDecreación: fecha,
                tipoSolicitud: 'Registro de maguey', nombreRazon: solicitud.nombrerazonsocial,
                noSocio: solicitud.numerocliente, Nombre: 'fc_06_registrodemaguey',
                idlogin: solicitud.idlogin, uri: 'FC_06/obtenerFormatoFC06/',
                Revisor: nombre?.[0] !== undefined ? revisor : '', hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_08_solicitudrenvacioncertificados.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc08_renvacioncertificado, FechaDecreación: fecha,
                tipoSolicitud: 'Renovación de certificados', nombreRazon: solicitud.nombrerazonsocial,
                noSocio: solicitud.numerocliente, Nombre: 'fc_08_solicitudrenvacioncertificados',
                idlogin: solicitud.idlogin, uri: 'FC_08/obtenerFormatoFC08/',
                Revisor: nombre?.[0] !== undefined ? revisor : '', hora_solicitud: solicitud?.hora_solicitud,
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios
            })
        })
        solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            // const filtro = clientes.filter(anexo => anexo.idlogin === solicitud.idlogin)
            // const cliente = dispatch(obtenerIdCliente(solicitud.idlogin))
            rows.push({
                id: uuidv4(), folio: solicitud.folio, Folio: solicitud.idfc09_solicitudcertificado, FechaDecreación: fecha,
                tipoSolicitud: 'Certificado NOM para exportación', nombreRazon: solicitud.nombrecliente,
                noSocio: solicitud.numerocliente, Nombre: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram',
                idlogin: solicitud.idlogin, uri: 'FC_09/obtenerFormatoFC09/',
                Revisor: nombre?.[0] !== undefined ? revisor : '', hora_solicitud: solicitud?.hora_solicitud,
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios
            })
        })
        solicitudes.fc_30_notificaciontrasladodeproducto.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), Folio: solicitud.idfc30_notificaciontrasladodepr, FechaDecreación: fecha,
                folio: solicitud.folio, tipoSolicitud: 'Traslado de producto', noSocio: solicitud.numerocliente,
                nombreRazon: solicitud.nombrecliente, idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
                Nombre: 'fc_30_notificaciontrasladodeproducto', idlogin: solicitud.idlogin, uri: 'FC_30/obtenerFormatoFC30/',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_31_solicitudseguimiento.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), Folio: solicitud.idfc31_solicitudseguimiento, FechaDecreación: fecha,
                folio: solicitud.folio, tipoSolicitud: 'Seguimiento', noSocio: solicitud.numerocliente,
                nombreRazon: solicitud.nombrerazonsocial, idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
                Nombre: 'fc_31_solicitudseguimiento', idlogin: solicitud.idlogin, uri: 'FC_31/obtenerFormatoFC31/',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_33_solicitudenvasadonacional.map(solicitud => {
            let revisor = ''
            let nombre = solicitud.revisor?.split(' ')
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            rows.push({
                id: uuidv4(), Folio: solicitud.idfc33_solicitudenvasadonaciona, folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
                Nombre: 'fc_33_solicitudenvasadonacional', idlogin: solicitud.idlogin, uri: 'FC_33/obtenerFormatoFC33/',
                tipoSolicitud: 'Venta nacional', Revisor: nombre?.[0] !== undefined ? revisor : '',
                nombreRazon: solicitud.nombrecliente, noSocio: solicitud.numerocliente,
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_34_notificacionsuspencionyreactivacion.map(solicitud => {
            let revisor = ''
            let nombre = solicitud.revisor?.split(' ')
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), Folio: solicitud.idfc34_notificacionsuspencion,
                folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
                tipoSolicitud: 'Notificación suspensión y reactivación', Revisor: nombre?.[0] !== undefined ? revisor : '',
                Nombre: 'fc_34_notificacionsuspencionyreactivacion',
                idlogin: solicitud.idlogin, uri: 'FC_34/obtenerFormatoFC34/',
                nombreRazon: solicitud.nombrerazonsocial, noSocio: solicitud.numerocliente,
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_35_notificaciondeserviciosvarios.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), Folio: solicitud.idfc35_notificacionserviciosvar,
                folio: solicitud.folio, tipoSolicitud: 'Servicios varios', noSocio: solicitud.numerocliente,
                FechaDecreación: fecha, Nombre: 'fc_35_notificaciondeserviciosvarios',
                idlogin: solicitud.idlogin, uri: 'FC_35/obtenerFormatoFC35/', nombreRazon: solicitud.nombrerazonsocial,
                Revisor: nombre?.[0] !== undefined ? revisor : '',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_36_solicituddeactualizacion.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let accion = ''
            if (solicitud.cambiorazon) accion = 'Cambio de razón social o régimen fiscal'
            else {
                if (solicitud.actualizaciondomicilio) accion = 'Actualización de domicilio fiscal'
                if (solicitud.cambioresponsable) accion = 'Actualización de representante legal'
                if (solicitud.cambiorepresentante) accion = 'Actualización de persona autorizada para trámite'
                if (solicitud.actualizarmedioscontacto) accion = 'Actualización medios de contacto'
                if (solicitud.actualizacioncadena) accion = 'Actualización de cadena productiva'
                if (solicitud.cambioresponsableinst) accion = 'Actualización de responsables de instalaciones'
                if (solicitud.actualizacioninstalaciones) accion = 'Alta o baja instalaciones'
                if (solicitud.actualizacionprediosviveros) accion = 'Baja predios/viveros'
                if (solicitud.actualizarmarcas) accion = 'Actualización de marcas'
            }

            rows.push({
                id: uuidv4(), Folio: solicitud.idfc36_solicitudactualizacion,
                folio: solicitud.folio, tipoSolicitud: 'Actualización: ' + accion, noSocio: solicitud.numerocliente,
                FechaDecreación: fecha, Nombre: 'fc_36_solicituddeactualizacion',
                idlogin: solicitud.idlogin, uri: 'FC_36/obtenerUnaSolicitudFC_36/', nombreRazon: solicitud.nombrerazonsocial,
                Revisor: nombre?.[0] !== undefined ? revisor : '',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })
        })
        solicitudes.fc_40_solicituddeadquisiciondehologramas.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            rows.push({
                id: uuidv4(), Folio: solicitud.idfc40_solicitudadquisicionholo,
                folio: solicitud.folio, tipoSolicitud: 'Compra de hologramas', noSocio: solicitud.numerocliente,
                FechaDecreación: fecha, Nombre: 'fc_40_solicituddeadquisiciondehologramas',
                idlogin: solicitud.idlogin, uri: 'FC_40/obtenerFormatoFC40/', nombreRazon: solicitud.nombrerazonsocial,
                Revisor: nombre?.[0] !== undefined ? revisor : '',
                hora_solicitud: solicitud?.hora_solicitud
            })

        })
        solicitudes.fc_41_solicitudparabebidasconmezcal.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            rows.push({
                id: uuidv4(), Folio: solicitud.idfc41_solicitudparabebidasconm,
                folio: solicitud.folio, tipoSolicitud: 'Productos con mezcal', noSocio: solicitud.numerocliente,
                FechaDecreación: fecha, Nombre: 'fc_41_solicitudparabebidasconmezcal',
                idlogin: solicitud.idlogin, uri: 'FC_41/obtenerFormatoFC41/', nombreRazon: solicitud.nombrerazonsocial,
                Revisor: nombre?.[0] !== undefined ? revisor : '',
                numerosolicitudservicios: solicitud?.informacionmodalaceptada?.numerosolicitudservicios,
                hora_solicitud: solicitud?.hora_solicitud
            })

        })
    }

    const btnReporteClientes = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        await dispatch(actualizarLoadingApp_true())

        let arregloSolicitudes = []

        solicitudes.fc_08_solicitudrenvacioncertificados.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilio?.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: 'REN CERT', nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_09_solicitudemicioncertificadonomexportacionyentregahologram.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            let tipoExportacion = 'EXPORTACION'
            if (solicitud?.emicioncertificadopromocion) tipoExportacion = 'EXPORTACION PROMOCION'

            let domicilio = solicitud?.domicilioproducto?.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: tipoExportacion, nombreempresa: solicitud.nombrecliente?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_30_notificaciontrasladodeproducto.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            let tipoSupervision = ''
            if (solicitud?.superviciondocumental) tipoSupervision = 'TRASLADO DOCUMENTAL'
            if (solicitud?.supervicionsitio) tipoSupervision = 'TRASLADO EN SITIO'

            let domicilio = solicitud?.domiciliosolicitante?.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: tipoSupervision, nombreempresa: solicitud.nombrecliente?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.fechapropuestaactividad?.substring(0, 10),
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_31_solicitudseguimiento.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilio?.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: 'SEGUIMIENTO', nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_33_solicitudenvasadonacional.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilioproducto?.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: 'NACIONAL', nombreempresa: solicitud.nombrecliente?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_34_notificacionsuspencionyreactivacion.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]
            let tipoServicio = ''
            if (solicitud?.servicioactividad == 'suspension') tipoServicio = 'suspensión '
            if (solicitud?.servicioactividad == 'reactivacion') tipoServicio = 'reactivación '
            if (solicitud?.servicioinstalacion == 'produccion') tipoServicio += 'UP'
            if (solicitud?.servicioinstalacion == 'envasado') tipoServicio += 'UE'
            if (solicitud?.servicioinstalacion == 'almacen') tipoServicio += 'UA'
            let domicilio = solicitud?.domicilio.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: tipoServicio?.toUpperCase(), nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_35_notificaciondeserviciosvarios.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilio.replace(/NULL/gi, "S/N").replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: 'SERVICIOS VARIOS', nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion,
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })
        solicitudes.fc_36_solicituddeactualizacion.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilio?.replace(/NULL/gi, "S/N")?.replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4 && (solicitud?.informacionmodalaceptada?.fechainspeccion != '' && solicitud?.informacionmodalaceptada?.fechainspeccion != undefined
                && solicitud?.informacionmodalaceptada?.fechainspeccion != null)) arregloSolicitudes.push({
                    numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                    numcliente: solicitud?.numerocliente, tiposervicio: 'ACTUALIZACIÓN', nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                    domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.informacionmodalaceptada?.fechainspeccion?.substring(0, 10),
                    inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
                })
        })
        solicitudes.fc_41_solicitudparabebidasconmezcal.map(solicitud => {
            let fecha = solicitud.fechasolicitud.substring(0, 10)
            let nombre = solicitud.revisor?.split(' ')
            let revisor = ''
            if (nombre === undefined) revisor = ''
            else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
            else revisor = nombre[0] + ' ' + nombre[1]

            let domicilio = solicitud?.domicilio?.replace(/NULL/gi, "S/N")?.replace(/null/gi, "S/N");
            if (solicitud?.idestatusdesolicitudes == 4) arregloSolicitudes.push({
                numsolicitud: solicitud?.informacionmodalaceptada?.numerosolicitudservicios, fecharecepcion: fecha, fechasolicitud: fecha, revisor: revisor,
                numcliente: solicitud?.numerocliente, tiposervicio: 'BEBIDAS', nombreempresa: solicitud.nombrerazonsocial?.toUpperCase(),
                domicilioinstalaciones: domicilio?.toUpperCase(), fechapropuesta: solicitud?.fechapropuesta?.substring(0, 10),
                inspectorasignado: solicitud?.informacionmodalaceptada?.inspectorasignado?.toUpperCase() + ' TEL:' + solicitud?.informacionmodalaceptada?.telefonoinspector,
            })
        })

        arregloSolicitudes.sort((a, b) => new Date(a.fecharecepcion) - new Date(b.fecharecepcion))
        arregloSolicitudes.map((solicitud, index) => {
            solicitud.id = index + 1
        })
        const workbook = new excelJS.Workbook();
        const worksheetSolicitudes = workbook.addWorksheet("SOLICITUDES");
        const worksheetCompleto = workbook.addWorksheet("COMPLETO");

        let abc = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'];

        worksheetCompleto.columns = [
            { header: "NO.", key: "id", width: 15 },
            { header: "No DE SOLICITUD.", key: "numsolicitud", width: 20 },
            { header: "FECHA DE RECEPCION SOLICITUD ASOCIADO (CORREO)", key: "fecharecepcion", width: 25 },
            { header: "FECHA DE SOLICITUD OC-UI", key: "fechasolicitud", width: 25 },
            { header: "No DE CLIENTE", key: "numcliente", width: 20 },
            { header: "TIPO DE SERVICIO", key: "tiposervicio", width: 40 },
            { header: "NOMBRE DE LA EMPRESA", key: "nombreempresa", width: 50 },
            { header: "DOMICILIO DE LAS INSTALACIONES", key: "domicilioinstalaciones", width: 50 },
            { header: "FECHA PROPUESTA DE ACTIVIDADES (OC)", key: "fechapropuesta", width: 25 },
            { header: "INSPECTOR ASIGNADO", key: "inspectorasignado", width: 40 },
        ];
        abc.slice(0, 10).map(key => {
            worksheetCompleto.getCell(key).fill = {
                type: 'pattern',
                pattern: 'solid',
                height: 150,
                fgColor: { argb: '002161' },
                backgroundColor: 'white'
            };
            worksheetCompleto.getCell(key).alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });
        arregloSolicitudes.forEach((solicitud) => {
            worksheetCompleto.addRow(solicitud);
            const row = worksheetCompleto.lastRow;
            row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(6).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(7).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(8).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(9).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(10).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
        worksheetCompleto.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
        });

        worksheetSolicitudes.columns = [
            { header: "No DE SOLICITUD.", key: "numsolicitud", width: 20 },
            { header: "No DE CLIENTE", key: "numcliente", width: 20 },
            { header: "TIPO DE SERVICIO", key: "tiposervicio", width: 50 },
            { header: "FECHA", key: "fechasolicitud", width: 15 },
            { header: "QUIEN LO SOLICITA", key: "revisor", width: 40 },
        ];
        abc.slice(0, 5).map(key => {
            worksheetSolicitudes.getCell(key).fill = {
                type: 'pattern',
                pattern: 'solid',
                height: 150,
                fgColor: { argb: 'gray' },
                backgroundColor: 'white'
            };
            worksheetSolicitudes.getCell(key).alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });
        arregloSolicitudes.forEach((solicitud) => {
            worksheetSolicitudes.addRow(solicitud);
            const row = worksheetSolicitudes.lastRow;
            row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
        worksheetSolicitudes.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
        });

        await dispatch(actualizarLoadingApp_false())
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const blob = new Blob([buffer], { type: fileType });
            saveAs(blob, 'ReporteSolicitudes' + fechaHoy.substring(0, 10) + EXCEL_EXTENSION);
        } catch (err) {
            console.log("error ", err)
        }
    }
    const btnProductor = async (params) => {
        await dispatch(actualizarLoadingApp_true())
        console.log(params)
        let detalle = await dispatch(obtenerSolicitudDetalleFC_01(params.id))
        console.log(' detalle ', detalle)
        let calle = detalle?.payload?.calle == 'Otro' ? detalle?.payload?.otracalle : detalle?.payload?.calle
        let solicitudFC_06 = {
            domiciliosolicitante: calle + ',' + (detalle?.payload?.numInt || 'S/N') + ',' + (detalle?.payload?.numExt || 'S/N') + ',' +
                detalle?.payload?.colonia + ',' + detalle?.payload?.localidad + ',' + detalle?.payload?.municipioalcaldia + ',' +
                detalle?.payload?.estado + ',' + detalle?.payload?.codigopostal,
            nombreresponsable: '',
            telefono: detalle?.payload?.telefono,
            email: detalle?.payload?.correoelectronico,
            predio: true,
            vivero: false,
            fechaaceptada: detalle?.payload?.fechaaceptada,
            fc_06_anexopredio: detalle?.payload?.fc_01_anexoproductor
        }
        const data = {
            tipoSolicitud: 'FC_06',
            solicitudFC_06,
            dataCliente: {
                numerosocio: detalle?.payload?.numerosocio,
                nombrerazonsocial: detalle?.payload?.nombrerazonsocial,
                idSolicitud: detalle?.payload?.idfc01_solicitudregistro
            },
        }

        try {
            const result = await dispatch(generarDocumentosProductorMaguey(data))
            if (result.payload) {
                const file = new Blob([result.payload], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL, '_blank');
            }
        } catch (error) {
            console.log(error)
        }
        await dispatch(actualizarLoadingApp_false())
    }
    return (
        <div className='container'>
            <div className='row'>
                <h3 className='text-center tm'>Control de registro de solicitudes</h3><br />
                {dataUser?.[0]?.idrol == 1 && solicitudesStatus == 4 &&
                    <div className={'row'} style={{ display: 'flex', alignItems: 'end', justifyContent: 'end' }}>
                        <button className="btn btn-outline-success col-3" onClick={() => btnReporteClientes()}> <DownloadIcon /> Reporte de Excel </button>
                    </div>
                }
                <div className='col-12 mt-1 ms-3 text-center' >
                    <div style={{ height: 600, width: obtenerAncho() < 1500 ? '105%' : solicitudesStatus == 4 ? '100%' : '90%', color: 'black' }}>
                        <DataGrid
                            // autoHeight={true}
                            rows={rows}
                            columns={columns}
                            pageSize={10}
                            components={{
                                Toolbar: QuickSearchToolbar,
                            }}
                            //sortModel={[{ field: 'FechaDecreación', sort: 'desc' }]}
                            //sortModel={[{ field: 'folio', sort: 'desc' }]}
                            //slots={{ toolbar: QuickSearchToolbar }}
                            initialState={{ sorting: { sortModel: [{ field: 'FechaDecreación', sort: 'desc' }], }, }}
                            //initialState={{ sorting: {  sortModel: [{ field: 'folio', sort: 'desc' }], }, }}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
                {modalComponentRevisores()}
                {modalComponent()}
            </div>
        </div>
    )
}

export default withRouter(AtencionAClientesComponent)
